import { computed, ref } from "vue";
import { currencies } from "@xs2event/js-lib";
import { DistributorsApi } from "@xs2event/js-lib/api";
import { useUserStore } from "@/store/user";

const mostUsedCurrencies = ["EUR", "GBP", "USD"];

// Shared by the top bar's currency menu and the mobile navigation. Anything but EUR goes through
// CurrencyChangeModal first, so the caller renders that modal with `showModal` / `selectedCurrency`.
export const useCurrencySelect = () => {
  const userStore = useUserStore();
  const showModal = ref();
  const selectedCurrency = ref();
  const showAll = ref(false);

  const popularFxRates = () => {
    if (showAll.value) {
      return userStore.fxRates;
    } else {
      return userStore.fxRates.filter((i) => mostUsedCurrencies.includes(i[0]));
    }
  };

  const currency = computed(() => currencies.find((c) => c.code == userStore.selectedCurrency));

  const currencySymbol = computed(() => currency.value?.symbol);

  const currencyName = computed(() => currency.value?.name);

  const distributorsApi = new DistributorsApi();
  const selectCurrency = async (currency: string) => {
    if (currency !== "EUR") {
      selectedCurrency.value = currency;
      showModal.value = true;
    } else {
      // Currency logging
      await distributorsApi.distributorcurrencychangePost({
        requestedDistributorId: userStore.distributor_id,
        distributorCurrencyChangeRequest: { preferredCurrency: "EUR" },
      });
      showModal.value = false;
      localStorage.fxRate = "EUR";
      setTimeout(() => window.location.reload());
    }
  };

  return { showModal, selectedCurrency, showAll, popularFxRates, currencySymbol, currencyName, selectCurrency };
};
